import { Component, Prop } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import Avatar from '@shared/components/avatar/avatar.vue';

@Component({
  name: 'bpc-display-field-contact-avatar',
  components: {
    'bpc-avatar': Avatar,
  },
})
export default class DisplayFieldContactAvatar extends mixins(AbstractDisplayField) {
  @Prop(String) readonly username: string;

  get name() {
    return this.username ? this.username : this.item.fullname;
  }

  get size() {
    return this.fieldConfig?.size || 44;
  }

  get width() {
    return this.fieldConfig?.width || 44;
  }

  get height() {
    return this.fieldConfig?.height || 44;
  }

  currentImgField = 'defaultConversionUrl';
  imgFail = false;

  onImgError() {
    if (this.currentImgField === 'url') {
      this.imgFail = true;
    }
    if (this.currentImgField === 'defaultConversionUrl') {
      this.currentImgField = 'url';
    }
  }

  get avatarUrl() {
    if (this.imgFail) {
      return null;
    }
    if (this.value instanceof Array) {
      return this.value[0][this.currentImgField];
    }
    if (this.value instanceof Object) {
      return this.value[this.currentImgField];
    }
    return null;
  }
}
